import "../components/plasmic/inventory/plasmic.css"; // plasmic-import: k4MoYHGY6d3NVAoA3aDDg2/projectcss
// pages/_app.tsx
import "@/styles/globals.css";
import "@/styles/fonts-local.css";
import "@ckeditor/ckeditor5-editor-classic/theme/classiceditor.css";
import "@ckeditor/ckeditor5-image/theme/image.css";
import "../styles/xy-theme.css";
import type { AppProps } from "next/app";
import Head from "next/head";
import Link from "next/link";
import { useEffect, useState } from "react";
import { getCookie } from "cookies-next";
import { ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import { PlasmicRootProvider } from "@plasmicapp/react-web";
import { PlasmicQueryDataProvider } from "@plasmicapp/react-web/lib/query";
import { SupabaseClientContext } from "../components/SupabaseClientContext";
import { supabaseClient } from "../lib/supabase/client";
import { RealtimeProvider } from "../components/RealtimeProvider";
import { PageWrapper } from "../components/PageWrapper";

// ⭐ Import the generated Plasmic type
import {
  LocaleContext,
  LocaleValue
} from "../components/plasmic/inventory/PlasmicGlobalVariant__Locale";
function MyApp({ Component, pageProps }: AppProps) {
  // ⭐ Fallback must be a valid LocaleValue
  const [cookieContent, setCookieContent] = useState<LocaleValue>("english");
  useEffect(() => {
    const raw = getCookie("user-prefs");
    if (raw) {
      try {
        const parsed = JSON.parse(raw as string);

        // ⭐ Only assign if it's a valid LocaleValue
        const lang = parsed.language as LocaleValue;
        setCookieContent(lang ?? "english");
      } catch (err) {
        console.error("Invalid cookie JSON:", err);
        setCookieContent("english");
      }
    }
  }, []);
  return (
    <LocaleContext.Provider value={cookieContent}>
      <PlasmicRootProvider Head={Head} Link={Link}>
        <SupabaseClientContext.Provider value={supabaseClient}>
          <RealtimeProvider>
            <PageWrapper layoutData={pageProps.layoutData}>
              <PlasmicQueryDataProvider prefetchedCache={pageProps.queryCache}>
                <ConfigProvider locale={enUS}>
                  <Component {...pageProps} />
                </ConfigProvider>
              </PlasmicQueryDataProvider>
            </PageWrapper>
          </RealtimeProvider>
        </SupabaseClientContext.Provider>
      </PlasmicRootProvider>
    </LocaleContext.Provider>
  );
}
export default MyApp;
